import { render } from "./Instrutor.vue?vue&type=template&id=424618d0&scoped=true"
import script from "./Instrutor.vue?vue&type=script&lang=ts"
export * from "./Instrutor.vue?vue&type=script&lang=ts"

import "./Instrutor.vue?vue&type=style&index=0&id=424618d0&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-424618d0"

export default script